import React from "react";
import { Paginator } from "@orange-marmalade/paginate-this";
import { connect } from "react-redux";
import { Search as AccountingLogSearch } from "MODULES/shared/components";
import Table from "./Table";
import pagination from "../pagination";

function Search() {
  return (
    <AccountingLogSearch search={pagination} syncWithUrl>
      {searchProps => {
        const filtersSet = searchProps.paginator.toJS().filters;
        return (
          <div>
            <div>
              <h2>Accounting Logs</h2>
            </div>
            <Table {...searchProps} filtersSet={filtersSet} />
            <Paginator {...searchProps} listId="searchAccountinglogs" />
          </div>
        );
      }}
    </AccountingLogSearch>
  );
}

export default connect(undefined)(Search);



// WEBPACK FOOTER //
// ./app/modules/AccountingLogs/Search/Search.jsx